import React, { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import { Form, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useToastContext, Toast } from 'components/Toast';
import * as api from 'utils/api';
import Sidebar from 'components/Common/Sidebar';
import { useModalContext } from 'components/ModalContext';
import { ModalKey } from 'constants/modal';
import { useAppContext } from 'components/AppContext';
import UsersTable from './UsersTable';

const ITEMS_PER_PAGE = 10;

export default function Users() {
  const history = useHistory();
  const { request } = useAppContext();
  const { toastError } = useToastContext();
  const { showModal } = useModalContext();
  const [users, setUsers] = useState([]);
  const [page = 1, setPage] = useQueryParam('page', NumberParam);
  const [numPages, setNumPages] = useState(0);
  const [searchText, setSearchText] = useQueryParam('search', StringParam);
  const [userId = null, setUserId] = useQueryParam('userId', NumberParam);

  const [debouncedSearchText] = useDebounce(searchText, 500, {
    leading: true,
    trailing: true,
  });

  const fetchUsers = useCallback(async () => {
    const { error, result, success } = await request(api.getSuspiciousUsers({
      limit: ITEMS_PER_PAGE,
      offset: (page - 1) * ITEMS_PER_PAGE,
      search: debouncedSearchText,
    }));

    if (success) {
      setUsers(result.users);
      setNumPages(Math.ceil(result.count / ITEMS_PER_PAGE));
    } else {
      toastError(error);
    }
  }, [toastError, page, request, debouncedSearchText]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers, page]);

  useEffect(() => {
    if (userId) {
      showModal(ModalKey.EDIT_USER, {
        userId,
        onClose: () => {
          setUserId(null);
          fetchUsers();
        },
      });
    } else {
      showModal(null);
    }
  }, [userId, showModal, setUserId, fetchUsers]);

  return (
    <div className="main users">
      <Sidebar />
      <div className="right-part">
        <Toast />
        <div className="title">
          <Breadcrumb>
            <Breadcrumb.Item
              active={false}
              onClick={() => {
                history.push('/users');
              }}
            >
              Users
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              Suspicious Users
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="sus-title">
          Users who come from the same ip addresses
        </div>
        <div className="filters">
          <Form.Group>
            <Form.Label>Search by email or name</Form.Label>
            <Form.Control
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
            />
          </Form.Group>
        </div>

        <UsersTable
          users={users}
          setUserId={setUserId}
          page={page}
          setPage={setPage}
          numPages={numPages}
        />
      </div>

    </div>
  );
}
